import React from "react";

const StudentCardSearchForm = ({
  searchTerm,
  setSearchTerm,
  searchCards,
  setCards,
  setPage,
  placeholder
}) => {
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchCards(e);
  };

  const handleReset = (e) => {
    e.preventDefault();
    setCards(e);
  };

  const handleSearchQueryChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setPage(1);
    if (value === '') {
      setCards(e);
    }
};

  return (
    <form className="mg-t-10" onSubmit={handleSearchSubmit}>
      <div className="row gutters-5">
        <div className="col-8-xxxl col-lg-8 col-12 form-group">
        <input
                  type="text"
                  value={searchTerm} onChange={handleSearchQueryChange}
                  placeholder={placeholder}
                  style={{border: "1px solid grey"}}
                  className="form-control"
                />
        </div>

        <div className="col-4-xxxl col-lg-4 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini ml-2"
          >
            RESET
          </button>
        </div>
      </div>
    </form>
  );
};

export default StudentCardSearchForm;
